module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "ct",
    attrs: {
      "id": "d7e4957"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/Impe_ISBN9781418517243_epub_c5_r1#d7e3165",
      "id": "d14e194"
    }
  }, [_vm._v("PREFACE ")])]), _vm._v(" "), _c('p', {
    staticClass: "ser"
  }, [_c('img', {
    staticStyle: {
      "max-width": "100%"
    },
    attrs: {
      "alt": "RevelationRevealed_0003_001",
      "id": "d14e196",
      "src": "images/RevelationRevealed_0003_001.jpg"
    }
  })]), _c('p', {
    staticClass: "default",
    attrs: {
      "id": "d7e5027s"
    }
  }, [_c('br'), _c('br')]), _vm._v(" "), _c('p', {
    staticClass: "tx1",
    attrs: {
      "id": "d7e5027"
    }
  }, [_vm._v("THE BOOK OF REVELATION is the culmination of Bible prophecy—the point at which all the prophecies of the ages converge and find their ultimate fulfillment. Revelation discloses the future of the Jew, Gentile, and the Church of the Lord Jesus Christ. Within its pages are specific details concerning the Saviour’s return, the establishment of His Millennial kingdom, and finally, the eternal state of both the saved and the lost.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e5327"
    }
  }, [_vm._v("The word "), _c('i', [_vm._v("revelation ")]), _vm._v("comes from the Greek "), _c('i', [_vm._v("apokalupsis")]), _vm._v(", meaning “an uncovering or unveiling.” For this reason, the Book of Revelation is also known as the Apocalypse. In either case, the definition reflects the fact that God has made known to mankind those eternal, supernatural truths and realities which man, on his own, could never realize or discover.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e5657"
    }
  }, [_vm._v("The Book of Revelation is the final work of the New Testament and the Revelation of Jesus Christ, which details world history from the time of John (the Early Church Age) to eternity. It constitutes God’s last special revelation to mankind this side of heaven. Simply stated, Bible prophecy and Revelation are history written in advance. They form God’s description of future facts and events. Such prophecy is completely trustworthy because God is omniscient. ")]), _vm._v(" "), _c('p', {
    staticClass: "tx1",
    attrs: {
      "id": "d7e5958"
    }
  }, [_vm._v("He knows all things, whether they be actual or merely possible, and He knows them perfectly from all eternity. Acts 15:18 states: “Known unto God are all His works from the beginning of the world.” Thus, the Almighty is able to fully and accurately describe the future in advance of its actual occurrence.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e6278"
    }
  }, [_vm._v("Current international events reflect exactly the conditions and happenings predicted throughout the Bible for the last days of this age. Yet, comparatively little prophetic teaching and preaching are currently taking place. This is probably due to the fact that this field of endeavor involves a great amount of research and study (see 2 Timothy 2:15).Millions more prefer not to have prophecy explained to them because they would rather live by the world’s standards and dictates. As individuals who are seeking satisfaction and rewards in this life, they are obviously not anxiously anticipating Christ’s return. ")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e6798"
    }
  }, [_vm._v("As we walk through the Book of Revelation together, remember that this special message has been given to reveal God’s truth, not conceal it, and to clarify God’s eternal purpose, not mystify it. I have not attempted to present an elaborate outline or engage in the use of heavy theological terminology. My goal is simplicity through a verse-by-verse analysis. I trust that, as a result, each reader will gain a clear understanding of the blessed truths the Book of Revelation contains.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e7118"
    }
  }, [_vm._v("This work was prepared to alert millions to the fact that Jesus is coming soon—perhaps today!")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5507a2df","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Impe_ISBN9781418517243_epub_c7_r1.vue
// module id = 69
// module chunks = 0